var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Fieldset',{attrs:{"apply":"","title":_vm.title,"subtitle":_vm.subtitle,"columns":_vm.columns}},[_vm._t("default"),(_vm.hasInfo)?_c('template',{slot:"action"},[_c('Tooltip',{attrs:{"content":_vm.information}})],1):_vm._e()],2)}
var staticRenderFns = []

export { render, staticRenderFns }